import { Component, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TestHooks } from './charge-table.hooks';
import { DocketSummaries } from '@models/teranet';

@Component({
	selector: 'app-docket-summary-charge-table',
	templateUrl: './charge-table.component.html',
	styleUrls: ['./charge-table.component.scss'],
	standalone: false,
})
export class ChargeTableComponent {
	testHooks = TestHooks;

	@Input() set summary(summaries: DocketSummaries) {
		if (summaries) {
			this._summaries = summaries;
			this.calcTotals(summaries);
			this.filter();
		}
	}

	public displayedColumns: string[] = [
		'date',
		'time',
		'description',
		'user',
		'amount',
		'hst',
	];
	public _summaries: DocketSummaries;
	public dataSource = new MatTableDataSource();

	public total = 0;
	public totalHST = 0;
	public teranet_title_hst_appl = 0;
	public teranet_name_hst_appl = 0;
	public teranet_other_hst_appl = 0;

	public teranet_title_non_hst_appl = 0;
	public teranet_name_non_hst_appl = 0;
	public teranet_other_non_hst_appl = 0;

	filter() {
		this.dataSource.data = [
			...this._summaries.writs.items,
			...this._summaries.parcel.items,
		];
	}

	calcTotals(summaries: DocketSummaries) {
		this.totalHST = summaries.total_hst;
		this.total = summaries.total + summaries.total_hst;
	}
}
